module.exports = __webpack_public_path__ + "static/media/CALAMARVER_MENU-normal.745b2a97.png";